import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { publishQueryKeys } from '../queries/publishQueryKeys.js';
import { toast } from '../../store/alerts.js';
import { getSlug } from '@fabric-app/utils/url/getSlug';

const useMutationPublishEnable = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ resourceId, resourceName }) => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/publish",
        params: {
          resourceId
        }
      }, {
        method: "post",
        body: {
          allowIndex: true,
          allowDownload: true,
          allowCopy: true,
          slug: getSlug(resourceName)
        }
      });
    },
    onSuccess: (data, { resourceId, resourceKind }) => {
      queryClient.setQueryData(publishQueryKeys.resourcePublishDetails(resourceId), data);
      toast({
        content: `${resourceKind === "folder" ? "Space" : "File"} published`,
        id: "publish-enable-success"
      });
    },
    onError: () => {
      toast({
        content: "Failed to publish",
        id: "publish-enable-error"
      });
    }
  });
  return mutation;
};

export { useMutationPublishEnable };
//# sourceMappingURL=useMutationPublishEnable.js.map
